export { default } from './CTACard'
